
import { LibraryContextProvider } from '../../library/context';
import { Playlist } from '../../playlist/components/Playlist';
import { Tools } from './Tools';

export const Sidebar = () => (
  <div className='grow flex flex-col min-h-0'>
    <LibraryContextProvider>
      <Tools />
    </LibraryContextProvider>
    <div className='bg-white text-neutral-900 rounded-sm grow shrink relative z-30 flex flex-col mb-4 min-h-0'>
      <Playlist />
    </div>
  </div>
);
